import { InjectionToken } from '@angular/core';

export const ENTITY_SERVICE = new InjectionToken('ENTITY_SERVICE');